<template>
  <div class="object-grid mt-15 mt-md-30">
    <div v-if="!$root.isMobile" class="col-12 col-sm-6 col-lg-4 col-xl-3">
      <object-filter v-model="value" @input="$emit('input', value)" />
    </div>
    <div class="col-12 col-sm-6 col-lg-8 col-xl-9">
      <div v-if="containers.length > 0" class="row">
        <div class="col-12">
          <h6 class="fs-17 fw-b mt-15 mb-15">{{ $t(`${$options.name}.containers`) }}</h6>
        </div>
        <el-container class="col-12 col-sm-6 col-xl-3 mb-md-30 small" paddingClass="px-20 py-45" v-for="sub_container in containers" :key="sub_container.id" :container="sub_container" />
      </div>
      <div class="row">
        <div v-if="containers.length > 0" class="col-12">
          <h6 class="fs-17 fw-b mt-15 mb-15">{{ $t(`${$options.name}.objects`) }}</h6>
        </div>
        <el-empty-card v-if="!$root.isMobile && canEdit" class="col-12 col-sm-6 col-xl-3 mb-md-30" :center="true" size="small" @click="$emit('addObject')" :title="$t('general.object.new')" :description="$t('general.object.new_desc')" />
        <el-object class="col-12 col-sm-6 col-xl-3 mb-15 mb-md-30" v-for="(object, index) in objects" :key="object.key" :canEdit="canEdit" :object="object" @updated="handleObjectUpdate($event, index)"></el-object>
      </div>
    </div>
  </div>
</template>

<script>
import ObjectFilter from '@/views/object/partials/filter';

export default {
  name: 'views.object.partials.grid',

  components: {
    ObjectFilter,
    ElObject: () => import(/* webpackChunkName: "cards" */ '@/components/cards/object'),
    ElEmptyCard: () => import(/* webpackChunkName: "cards" */ '@/components/cards/empty'),
    ElContainer: () => import(/* webpackChunkName: "cards" */ '@/components/cards/container'),
  },

  props: {
    objects: {
      type: Array,
      default: () => {
        return [];
      },
    },
    containers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: false,
      default: () => {
        return {
          files: {},
          tags: {},
        };
      },
    },
  },
  methods: {
    handleObjectUpdate($event, index) {
      this.objects[index] = $event;
      this.$forceUpdate();
    },
  },
};
</script>
